import z from 'zod';

export const addEventMaskSchema = z.object({
  maskId: z.string().min(1, 'Mask is required'),
  overlayId: z.string().optional(),
});
